export class Reminder {
  id: string;
  serviceId: string;
  currentRollOutDay: string;
  outstandingRollOutDay: string;
  operatorId: string;
  createdAt: number; // Date number format
  updatedAt: number; // Date number format

  constructor() {
    this.id = "";
    this.serviceId = "";
    this.currentRollOutDay = "";
    this.outstandingRollOutDay = "";
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/reminder/reminder.ts